import { mergeStyles } from "@uifabric/merge-styles"
import React, { useEffect, useRef } from "react"

const style = mergeStyles({
    background: '#fff',
    width: '100%',
    minHeight: 900,
    maxHeight: 900,
    padding: 36,
    boxSizing: 'border-box',
    borderRadius: 24,
    boxShadow: '0px 0px 4px 4px rgba(0, 0, 0, 0.025)',
    fontSize: 14,
    fontFamily: 'Fira Code',
    overflowY: 'scroll',
    outline: 'none',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    transition: 'border 0.2s',
    'selectors': {
        ':hover': {
            border: '1px solid rgba(0, 0, 0, 0.25)'
        }
    }
})

export const TextBox = ({onPaste, children} : {onPaste: Function, children: JSX.Element | JSX.Element[]}) => {
    return (
        <div className={style} onPaste={(e: React.ClipboardEvent) => {
            e.preventDefault()
            e.stopPropagation()
            if (e.clipboardData.getData) {
                let data = e.clipboardData.getData("text/plain")
                onPaste(data)
            }
        }}>
            {children}
        </div>
    )
}